import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";

import errorImage from "./error-500.png";

interface ErrorPageProps {
  redirectRoute?: string;
  buttonText?: string;
  automaticRedirect?: boolean;
  /** Prefix used to build data-testids for the panel and redirect button. */
  testId?: string;
}

export const ErrorPage = ({
  redirectRoute = "/",
  buttonText = "Go to Security Journey",
  automaticRedirect = true,
  testId = "error-page",
}: ErrorPageProps) => {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    if (!automaticRedirect) return;

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          window.location.href = redirectRoute;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [automaticRedirect, redirectRoute]);

  const handleRedirect = () => {
    window.location.href = redirectRoute;
  };

  return (
    <Panel
      data-testid={testId}
      pt={{
        root: { className: "bg-transparent border-none" },
        content: { className: "bg-transparent" },
      }}
    >
      <div className="flex flex-col items-center justify-center gap-12 pt-20">
        <h1 className="font-bold text-2xl">Whoops, looks like we've encountered an issue.</h1>
        <img src={errorImage} alt="Error image" className="max-w-1/2" />
        <p className="mb-4"> The page you are looking for doesn't exist or has been moved.</p>
        {automaticRedirect && (
          <p className="text-sm text-gray-600">Redirecting in {countdown} seconds...</p>
        )}
        <Button
          label={buttonText}
          icon="pi pi-home"
          data-testid={`${testId}-redirect-button`}
          onClick={handleRedirect}
        />
      </div>
    </Panel>
  );
};
